import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Helmet } from 'react-helmet';
import PaginationPanel from '@components/PaginationPanel/PaginationPanel';
import Table from './Table/Table';
import axiosInstance from '@src/axios-instance';
import AnnouncementModal from '@src/components/Elements/AnnouncementModal/AnnouncementModal';
import ConfirmModal from '@src/components/ConfirmModal/ConfirmModal';
import connect from 'react-redux/es/connect/connect';
import Auth from '@src/components/Elements/Auth/Auth';

class Announcements extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      annoucementModalActive: false,
      confirmModalActive: false,
      entity: {},
      loaded: false,
      pagination: {
        loaded: false,
        list: [],
        total: 0,
        page: 1,
        limit: 10,
        start: 0,
        end: 10,
        sort: null,
        direction: null,
        phraze: ''
      }
    };

    const { page, limit, sort, direction } = this.state.pagination;
    this.getList({ page, limit, sort, direction });
  }

  toggleModal = (modalType, entity) => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType],
      entity: entity !== undefined ? entity : {}
    }));
  };

  deleteItem = entityId => {
    const { page, limit, sort, direction } = this.state.pagination;

    axiosInstance()
      .delete(`/announcements/${this.state.entity.id}.json`)
      .then(response => {
        this.getList({ page, limit, sort, direction });
        this.toggleModal('confirmModalActive');
      })
      .catch(err => {});
  };

  getList = getData => {
    axiosInstance()
      .get('/announcements.json', { params: getData })
      .then(response => {
        this.setState({ pagination: { ...response.data }, loaded: true });
      })
      .catch(err => {
        alert(err);
      });
  };

  render = () => {
    const {
      page,
      limit,
      total,
      start,
      end,
      sort,
      direction
    } = this.state.pagination;
    return (
      <Container>
        <Helmet>
          <title>NXT Insurance Hub | EOIs</title>
        </Helmet>
        <h3>Announcements</h3>
        {this.state.loaded && (
          <div>
            <Auth action={'Annoucements::edit'}>
              <Row>
                <Col className={'text-right'}>
                  <button
                    className={'btn btn-primary px-3'}
                    onClick={() => this.toggleModal('annoucementModalActive')}
                  >
                    Create New Announcement
                  </button>
                </Col>
              </Row>
            </Auth>
            <Table
              {...this.state.pagination}
              onEntityClick={this.onEvidenceClick}
              paginationFunc={this.getList}
              userRole={this.props.role}
              onEdit={entity =>
                this.toggleModal('annoucementModalActive', entity)
              }
              onDelete={entity =>
                this.toggleModal('confirmModalActive', entity)
              }
            />
            <PaginationPanel
              page={page}
              limit={limit}
              total={total}
              start={start}
              end={end}
              sort={sort}
              direction={direction}
              paginationFunc={this.getList}
            />
          </div>
        )}
        {this.state.annoucementModalActive && (
          <AnnouncementModal
            entity={this.state.entity}
            toggle={() => this.toggleModal('annoucementModalActive')}
            isActive={this.state.annoucementModalActive}
            callback={() => this.getList({ page, limit, sort, direction })}
          />
        )}
        <ConfirmModal
          isActive={this.state.confirmModalActive}
          toggle={() => this.toggleModal('confirmModalActive', {})}
          title={'Confirmation'}
          body={'Are you sure to delete this announcement?'}
          confirmLabel={'Yes, Delete This Announcement'}
          confirmAction={() => this.deleteItem()}
        />
      </Container>
    );
  };
}

const mapStateToProps = state => {
  return {
    role: state.auth.role
  };
};
export default connect(
  mapStateToProps,
  null
)(Announcements);
